const W = (url, w = 1920) =>
  url.includes("images.pexels.com")
    ? `${url.split("?")[0]}?auto=compress&cs=tinysrgb&w=${w}`
    : `${url}&w=${w}&q=80&fit=max`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1588021624472-f8345116c8f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxsb25kb24lMjB0b3duaG91c2UlMjBsdXh1cnklMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  journey: "https://customer-assets-cm19k8pv.emergentagent.net/job_4d2cf119-1bd4-4349-a83d-32ee50f0670a/artifacts/e8a880c47de59fc3_Elin%E2%80%99s%20Consultancy%20Property%20Journey.webp",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_4d2cf119-1bd4-4349-a83d-32ee50f0670a/artifacts/a71339c89458df45_Elins%20consultancy%20Logo%20Gold.jpg",
  townhouse: "https://images.unsplash.com/photo-1609679604891-f69f884eddae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsb25kb24lMjB0b3duaG91c2UlMjBsdXh1cnklMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  mews: "https://images.pexels.com/photos/18729447/pexels-photo-18729447.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  period: "https://images.unsplash.com/photo-1609679604891-f69f884eddae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsb25kb24lMjB0b3duaG91c2UlMjBsdXh1cnklMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  greenery: "https://images.pexels.com/photos/10448423/pexels-photo-10448423.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  georgian: "https://images.unsplash.com/photo-1656161653385-43423cc7d009?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsb25kb24lMjB0b3duaG91c2UlMjBsdXh1cnklMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  livingWarm: "https://images.unsplash.com/photo-1691036561573-4b76998b60de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb20lMjB3YXJtJTIwbmV1dHJhbCUyMGVkaXRvcmlhbCUyMGRlc2lnbnxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  livingAmbient: "https://images.unsplash.com/photo-1646987916641-1f3c8992daa2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb20lMjB3YXJtJTIwbmV1dHJhbCUyMGVkaXRvcmlhbCUyMGRlc2lnbnxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  loungeSunlit: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb20lMjB3YXJtJTIwbmV1dHJhbCUyMGVkaXRvcmlhbCUyMGRlc2lnbnxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  penthouse: "https://images.unsplash.com/photo-1678762200388-51e11225d4de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb20lMjB3YXJtJTIwbmV1dHJhbCUyMGVkaXRvcmlhbCUyMGRlc2lnbnxlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
  dining: "https://images.pexels.com/photos/39829289/pexels-photo-39829289.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  office: "https://images.unsplash.com/photo-1705909773374-425e800059de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwcHJvcGVydHklMjBhZHZpc29yJTIwd29ya3NwYWNlJTIwcG9ydHJhaXQlMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmFsJTIwZGV0YWlsc3xlbnwwfHx8fDE3OTI1MjcwNjB8MA&ixlib=rb-4.1.0&q=85",
  loungeConsult: "https://images.unsplash.com/photo-1595846723416-99a641e1231a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwcHJvcGVydHklMjBhZHZpc29yJTIwd29ya3NwYWNlJTIwcG9ydHJhaXQlMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmFsJTIwZGV0YWlsc3xlbnwwfHx8fDE3OTI1MjcwNTZ8MA&ixlib=rb-4.1.0&q=85",
};

export const CINEMATIC = {
  heroHome: W("https://images.unsplash.com/photo-1603318445632-b5f58ba351a2?crop=entropy&cs=srgb&fm=jpg"),
  skylineSunset: W("https://images.pexels.com/photos/5235900/pexels-photo-5235900.jpeg"),
  skylineDusk: W("https://images.pexels.com/photos/1445334/pexels-photo-1445334.jpeg"),
  archCarved: W("https://images.pexels.com/photos/13696542/pexels-photo-13696542.jpeg"),
  archMasonry: W("https://images.unsplash.com/photo-1775723089197-fc58cbabe34d?crop=entropy&cs=srgb&fm=jpg"),
  archColumns: W("https://images.pexels.com/photos/11782967/pexels-photo-11782967.jpeg"),
  wideSalon: W("https://images.unsplash.com/photo-1611048267451-e6ed903d4a38?crop=entropy&cs=srgb&fm=jpg"),
  wideOak: W("https://images.unsplash.com/photo-1704040686413-2c607dbd2f06?crop=entropy&cs=srgb&fm=jpg"),
  grandHall: W("https://images.pexels.com/photos/6957083/pexels-photo-6957083.jpeg"),
  streetCrescent: W("https://images.pexels.com/photos/8893152/pexels-photo-8893152.jpeg"),
  streetArch: W("https://images.unsplash.com/photo-1758364454586-fc5cdca99767?crop=entropy&cs=srgb&fm=jpg"),
  officeWide: W(IMAGES.office),
  livingWarmWide: W(IMAGES.livingWarm),
};

export const GALLERY = [
  {
    img: W(IMAGES.livingWarm, 1400),
    alt: "Warm neutral living room with fine art and soft natural light",
    caption: "Interiors with quiet confidence",
    span: "md:col-span-7",
    height: "h-[320px] sm:h-[440px] md:h-[540px]",
  },
  {
    img: W(IMAGES.hero, 1200),
    alt: "Period London townhouse facade framed by mature foliage",
    caption: "Facades that hold their history",
    span: "md:col-span-5",
    height: "h-[320px] sm:h-[440px] md:h-[540px]",
    offset: "md:mt-20",
  },
  {
    img: W("https://images.pexels.com/photos/13696542/pexels-photo-13696542.jpeg", 1200),
    alt: "Classical stone carvings and grand columns on an exclusive London residence",
    caption: "Details worth a second look",
    span: "md:col-span-5",
    height: "h-[320px] sm:h-[400px] md:h-[440px]",
    offset: "md:-mt-10",
  },
  {
    img: W("https://images.pexels.com/photos/8893152/pexels-photo-8893152.jpeg", 1400),
    alt: "Golden-hour view along a prime residential London crescent",
    caption: "Streets made for walking home",
    span: "md:col-span-7",
    height: "h-[320px] sm:h-[400px] md:h-[440px]",
  },
];

export const CLIENT_STORIES = [
  {
    tag: "Property Investor",
    title: "A First Investment, From Search to Let",
    img: W(IMAGES.livingAmbient, 1200),
    alt: "A refurbished living space with warm ambient lighting, ready for the rental market",
    journey: ["Initial Consultation", "Property Sourcing", "Finance & Legal", "Let Agreed"],
    text: "A first-time investor came to us with a budget and a preference for North London. We shortlisted suitable flats, introduced a mortgage adviser and solicitor from our network, and coordinated the journey through to a successful let.",
    outcome: "From first call to keys in hand — one coordinated journey.",
  },
  {
    tag: "Leaseholder",
    title: "Clarity on a Leasehold Concern",
    img: W(IMAGES.period, 1200),
    alt: "A classic period London residence with ornate stonework",
    journey: ["Enquiry", "Consultation", "Solicitor Introduction", "Way Forward Agreed"],
    text: "A leaseholder worried about rising service charges asked where they stood. We reviewed their position, explained their options in plain language, and introduced a trusted solicitor for the formal steps that followed.",
    outcome: "Uncertainty replaced by a clear, confident plan.",
  },
  {
    tag: "Landlord",
    title: "A Tired Flat, Ready for the Rental Market",
    img: W(IMAGES.dining, 1200),
    alt: "A sophisticated refurbished dining area with bespoke lighting",
    journey: ["Viewing & Assessment", "Refurbishment Plan", "Coordinated Works", "Tenants Found"],
    text: "An investor's flat needed work before it could let well. We coordinated our development company for the refurbishment, then worked with estate agents to market the finished property and find suitable tenants.",
    outcome: "A careful refurbishment, coordinated from start to finish.",
  },
];

export const PARTNERS = [
  { name: "Sterling & Co.", logo: "/partners/p1.svg" },
  { name: "Hartley Estates", logo: "/partners/p2.svg" },
  { name: "Meridian Finance", logo: "/partners/p3.svg" },
  { name: "Oakfield Developments", logo: "/partners/p4.svg" },
  { name: "Chancery Legal", logo: "/partners/p5.svg" },
  { name: "Northgate Surveyors", logo: "/partners/p6.svg" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Property Investors", to: "/investors" },
  { label: "HMO Services", to: "/hmo-services" },
  { label: "Tenant & Leasehold", to: "/tenant-leasehold-advice" },
  { label: "How We Work", to: "/how-we-work" },
  { label: "Stamp Duty Calculator", to: "/stamp-duty-calculator" },
  { label: "Insights", to: "/insights" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT_DETAILS = {
  email: "hello@elinsconsultancy.co.uk",
  phone: "+44 (0)20 0000 0000",
  area: "London & Surrounding Areas",
};

export const SERVICES = [
  {
    num: "01",
    title: "Tenant & Leasehold Advice",
    text: "Independent guidance on tenancy and leasehold matters, helping you understand your position and next steps.",
    to: "/tenant-leasehold-advice",
  },
  {
    num: "02",
    title: "Property Sourcing for Investors",
    text: "Suitable opportunities matched to your goals, budget and preferred location.",
    to: "/investors",
  },
  {
    num: "03",
    title: "Refurbishment & Development",
    text: "Coordinated with our development company to prepare properties for the rental market.",
    to: "/investors",
  },
  {
    num: "04",
    title: "Professional Network",
    text: "Introductions to trusted mortgage advisers, solicitors, accountants and estate agents.",
    to: "/how-we-work",
  },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Discover", text: "Discuss your goals, budget and requirements." },
  { num: "02", title: "Source", text: "Identify and assess suitable opportunities." },
  { num: "03", title: "Finance & Legal", text: "Connect with mortgage advisers and solicitors." },
  { num: "04", title: "Refurbish", text: "Coordinate development and refurbishment partners." },
  { num: "05", title: "Find Tenants", text: "Work with estate agents to market the property." },
  { num: "06", title: "Financial Support", text: "Introduce accountants for property accounts." },
];

export const PROCESS_DETAIL = [
  {
    num: "01",
    title: "Discover",
    text: "Every journey begins with a conversation. We take the time to understand your goals, budget, preferred locations and timescales — whether you are investing, or seeking clarity on a tenancy or leasehold matter.",
  },
  {
    num: "02",
    title: "Source",
    text: "For investors, we identify and assess suitable property opportunities against your criteria, drawing on local knowledge and our professional connections to find options worth your attention.",
  },
  {
    num: "03",
    title: "Finance & Legal",
    text: "We introduce you to trusted mortgage advisers and solicitors from our network, so the financial and legal foundations of your purchase or matter are handled by the right people.",
  },
  {
    num: "04",
    title: "Refurbish",
    text: "Where a property needs work, we coordinate with our development company and refurbishment partners to prepare it for the rental market — keeping the process organised and transparent.",
  },
  {
    num: "05",
    title: "Find Tenants",
    text: "We work with estate agents to market the property and find suitable tenants, keeping you informed at each stage until the property is let.",
  },
  {
    num: "06",
    title: "Financial Support",
    text: "Finally, we introduce accountants who understand property, so your accounts and tax considerations are in good order from the start.",
  },
];

export const NETWORK = [
  { name: "Mortgage Advisers", text: "Support with finance options." },
  { name: "Solicitors", text: "Legal support for transactions and leases." },
  { name: "Accountants", text: "Property accounts and tax considerations." },
  { name: "Estate Agents", text: "Marketing and tenant finding services." },
  { name: "Development Company", text: "Refurbishment and improvement projects." },
];

export const TESTIMONIALS = [
  {
    quote: "Elin provided clear and practical advice on my leasehold issue. I felt informed and supported throughout the process.",
    name: "Sarah M.",
    role: "Leaseholder",
  },
  {
    quote: "Elin helped me find a great investment property and introduced me to trusted professionals. The whole process was straightforward and well managed.",
    name: "James T.",
    role: "Property Investor",
  },
  {
    quote: "A professional and friendly service. I highly recommend Elin's Consultancy to anyone looking for property advice or investment support.",
    name: "Priya K.",
    role: "Tenant",
  },
];
